exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media only screen and (max-width: 1034px) {\n.add-product-link[data-v-492be9dc] {\n    display: none !important;\n}\n}\n.actions-container[data-v-492be9dc] {\n  width: 100%;\n}", ""]);

// exports
